import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";
import { CollectionStyle, CollectionStylesResponse } from "@is/types";

const useManageAllItemsView = (
  onGetAllItems: (
    page: number,
    pageSize?: number
  ) => Promise<CollectionStylesResponse>
) => {
  const { t } = useTranslation(TranslationContext.Settings);
  const [isPending, setIsPending] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [totalStyles, setTotalStyles] = useState<number>(0);
  const [styles, setStyles] = useState<CollectionStyle[]>([]);

  const handleShowAllItems = useCallback(async () => {
    setIsPending(true);
    const allCollections = await onGetAllItems(page + 1);

    setStyles(allCollections.items);
    setPage(allCollections.page);
    setTotalStyles(allCollections.totalCount);
    setIsPending(false);
  }, [onGetAllItems, page]);

  const handleShowNextPage = useCallback(async () => {
    const allCollections = await onGetAllItems(page + 1);

    setStyles((styles) => [...styles, ...allCollections.items]);
    setPage(allCollections.page);
    setTotalStyles(allCollections.totalCount);
  }, [onGetAllItems, page]);

  const showShowMoreButton = useMemo(() => {
    return totalStyles > styles.length;
  }, [styles, totalStyles]);

  useEffect(() => {
    handleShowAllItems();
  }, []);

  return {
    t,
    styles,
    isPending,
    showShowMoreButton,
    handleShowNextPage,
  };
};

export default useManageAllItemsView;
